import { ICandidateProfessionalEntity, IGetCandidateProfessionalApiResponse } from '../types';

const toGetCandidateProfessionalEntity = ({
  data,
}: IGetCandidateProfessionalApiResponse): ICandidateProfessionalEntity => {
  return {
    id: data.id,
    isShortlisted: data.isShortlisted,
    officeStatus: data.officeStatus,
    officeId: data.postingDetails.officeId,
    postingProfession: data.postingDetails.professionType ?? undefined,
  };
};

export const CandidateProfessionalAdapters = {
  toGetCandidateProfessionalEntity,
};
